var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons System"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.8527 8.00869C13.7072 8.20394 10.5309 11.7656 10.5309 15.8874V19.6144L9.17166 22.3489C9.16927 22.3538 9.16693 22.3589 9.16465 22.3639C8.61784 23.5267 9.503 24.923 10.7883 24.923H15.1463C15.1463 26.6132 16.5331 28 18.2233 28C19.9135 28 21.3003 26.6132 21.3003 24.923H25.6573C26.9426 24.923 27.8289 23.527 27.2819 22.3639C27.2796 22.3589 27.2773 22.3538 27.2749 22.3489L25.9157 19.6144V15.6921C25.9157 11.3299 22.2558 7.8014 17.8527 8.00869ZM17.9248 9.54517C21.4736 9.3781 24.3772 12.1855 24.3772 15.6921V19.7947C24.3771 19.9136 24.4046 20.0308 24.4574 20.1373L25.8897 23.02C25.9818 23.2174 25.8752 23.3845 25.6573 23.3845H10.7883C10.5704 23.3845 10.4647 23.2177 10.5569 23.02V23.0189L11.9892 20.1373C12.042 20.0308 12.0694 19.9136 12.0693 19.7947V15.8874C12.0693 12.5538 14.6229 9.70069 17.9248 9.54517ZM16.6848 24.923H19.7618C19.7618 25.7816 19.0818 26.4615 18.2233 26.4615C17.3647 26.4615 16.6848 25.7816 16.6848 24.923Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.4039883db95b6b60a7c514cb35eca322.svg";
export { ForwardRef as ReactComponent };